import type React from 'react';

import { memo } from 'react';
import { Route } from 'react-router';
import { Routes } from '@datadog/browser-rum-react/react-router-v7';

import { PrivateRoutes } from './PrivateRoutes';
import { PublicRoutes } from './PublicRoutes';
import WithSuspense from './WithSuspense';

export type RouteLayout = 'default' | 'split-view';

export type RouteHandle = {
  layout?: RouteLayout; // 'split-view' removes PageWrapper padding for split-pane layouts
  hasBreadcrumbs?: boolean; // Shows back button in V2 header when true
};

export type RouteParams = {
  path: string;
  component: React.LazyExoticComponent<() => JSX.Element> | React.LazyExoticComponent<React.FC>;
  title?: string;
  role?: 'none' | 'protected';
  redirect?: string;
  handle?: RouteHandle;
};

export const allRoutes = [...PublicRoutes, ...PrivateRoutes].map((route: RouteParams) => {
  const Component = WithSuspense(route.component);

  function WrapperComponent() {
    return <Component />;
  }

  return {
    ...route,
    Component: memo(WrapperComponent),
  };
});

function GlobalRouter() {
  return (
    <Routes>
      {allRoutes.map(({ path, Component, handle }) => (
        <Route key={path} path={path} element={<Component />} handle={handle} />
      ))}
    </Routes>
  );
}

export default GlobalRouter;
